import apiFetcher from '@/utils/interCeptor';

/** Same as booking file upload: `POST api/v1/store/file` → `response.data.data.url` */
export async function uploadStoreFileApi(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiFetcher.post('api/v1/store/file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    const url = response?.data?.data?.url;
    if (typeof url !== 'string' || !url.trim()) {
        const err = new Error('STORE_FILE_UPLOAD_NO_URL') as Error & { response: typeof response };
        err.response = response;
        throw err;
    }
    return url.trim();
}
